export default [
    {
        name: 'queryContactsLists',
        url: '/lists'
    },
    {
        name: 'deleteContacts',
        url: '/delete'
    }
];
